import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/dashboard/context/AuthContext/AuthContext';
import { themesKey } from '@/dashboard/lib/queryKeys';
import { fetcher } from '@/dashboard/services/request';

export const getThemes = async (token, sellerId) => {
  return fetcher(`/sellers/${sellerId}/themes`, token);
};

export const getTheme = async (token, sellerId, themeId) => {
  return fetcher(`/sellers/${sellerId}/themes/${themeId}`, token);
};

export const updateTheme = async (token, sellerId, themeId, values) => {
  return fetcher(`/sellers/${sellerId}/themes/${themeId}`, token, {
    method: 'PUT',
    body: JSON.stringify(values),
  });
};

export const createTheme = async (token, sellerId, values) => {
  return fetcher(`/sellers/${sellerId}/themes`, token, {
    method: 'POST',
    body: JSON.stringify(values),
  });
};

export const deleteTheme = async (token, sellerId, themeId) => {
  return fetcher(`/sellers/${sellerId}/themes/${themeId}`, token, {
    method: 'DELETE',
  });
};

export default function useThemeQueries() {
  const { token, sellerId } = useAuth();

  return {
    getThemes: () => getThemes(token, sellerId),
    getTheme: themeId => getTheme(token, sellerId, themeId),
    updateTheme: ({ themeId, values }) => updateTheme(token, sellerId, themeId, values),
    createTheme: values => createTheme(token, sellerId, values),
    deleteTheme: themeId => deleteTheme(token, sellerId, themeId),
  };
}

export function useSellerThemes() {
  const { token, sellerId } = useAuth();
  return useQuery({
    queryKey: themesKey(sellerId),
    queryFn: () => getThemes(token, sellerId),
    enabled: !!token && !!sellerId,
  });
}
